/**
 * Stable FAQ section anchor IDs for sidebar scroll navigation.
 * Uses Contentful sys.id — unique and independent of display heading text.
 */
export function getFaqSectionAnchorId(sectionSysId: string): string {
  return `faq-section-${sectionSysId}`;
}

/**
 * Scroll to a FAQ section anchor with header offset.
 */
export function scrollToFaqSection(sectionSysId: string): void {
  const element = document.getElementById(getFaqSectionAnchorId(sectionSysId));

  if (!element) {
    return;
  }

  const headerHeight = Number.parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '80',
    10
  );

  window.scrollTo({
    top: element.offsetTop - headerHeight - 20,
    behavior: 'smooth',
  });
}
